import i18next from 'i18next';

/**
 * How an assessment came to exist — the API's `createdBy`.
 *
 * Mirrors `CreationMethod` in the backend
 * (`QHS.Backend/src/Data/Areas/Automation/Support/CreationMethod.cs`),
 * which has exactly these four values. Keep the two in step: this list
 * is what the Assessments table's default filter is built from, so a
 * value the backend adds and this file does not know about would be
 * hidden from the table by default rather than merely mislabelled.
 */
export const CREATION_METHODS = {
  automated: 'automated',
  integration: 'integration',
  manuallyCreated: 'manuallyCreated',
  instant: 'instant',
};

/**
 * Creators that are not a CreationMethod: the athenaNet bot stamps its own
 * name as `createdBy` on the assessments its schedule sync creates (API:
 * HandleAppointmentsChanges.BotCreatedBy). Listed so the Created By filter
 * can find them; API-created athena assessments stay `integration`.
 */
export const BOT_CREATORS = {
  athena: 'Athena',
};

export const CREATION_METHOD_OPTIONS = [
  { value: CREATION_METHODS.manuallyCreated, label: i18next.t('tables:manuallyCreated') },
  { value: CREATION_METHODS.integration, label: i18next.t('tables:integration') },
  { value: CREATION_METHODS.automated, label: i18next.t('tables:automated') },
  { value: CREATION_METHODS.instant, label: i18next.t('tables:instant') },
  { value: BOT_CREATORS.athena, label: i18next.t('tables:createdByAthena') },
];
